import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Box
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ToastContainer } from "react-toastify";
import logo from "../../Assets/logo.svg";
import { login } from "../../Services/LoginApi";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getUserDetails } from "../../Services/DashboardApi";
import { jwtDecode } from "jwt-decode";
import { ReactComponent as EyeIcon } from "./../../Assets/eye.svg";
import { ReactComponent as EyehideIcon } from "./../../Assets/eye_hide.svg";
const LoginPopup: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dashboard");
    }
  }, []);
  
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value.trim()) {
      setEmailError("Please enter an email address");
    } else if (!emailRegex.test(value)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPassword(value);

    if (!value.trim()) {
      setPasswordError("Please enter a password");
    } else {
      setPasswordError("");
    }
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    let isValid = true;
    if (!email.trim()) {
      setEmailError("Please enter an email address");
      isValid = false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setEmailError("Please enter a valid email address");
        isValid = false;
      } else {
        setEmailError("");
      }
    }
    if (!password.trim()) {
      setPasswordError("Please enter a password");
      isValid = false;
    } else {
      setPasswordError("");
    }
    if (!isValid) return;
    try {
      setLoading(true);
      const response = await login(email, password);
      if (response.success === true) {
        localStorage.setItem("token", response.token);
        const decodedToken: any = jwtDecode(response.token);
        const userId = decodedToken.id;
        const data = await getUserDetails(userId);
        if (!data.error) {
          localStorage.setItem("userDetails", JSON.stringify(data.userData));
       }
      toast.success("Login successful!");
      setTimeout(() => {
        navigate("/dashboard");
      }, 1500);
      }else{
        toast.error(response?.error.message);
      }
    } catch (error: any) {
      console.error("Login Error:", error);
      toast.error(error.response?.message);
    }finally {
      setLoading(false); 
    }
  };
  const forgotPassword = () => {
    navigate("/forget-password");
  };
  return (
    <Box sx={{ flexGrow: 1, overflowY: "auto", overflowX:'hidden' }}>
      <Grid container spacing={2} className="login">
        <Grid
          size={{ xs: 12, md: 5, sm: 12 }}
          className="login__left"
          sx={{ display: { xs: "none", sm: "none", md: "flex" } }}
        >
          <div className="login__left-image">
            <img src={logo} alt="logo" />
          </div>
          <div className="login__left-title">
            <p>Experience Management Portal</p>
          </div>
        </Grid>

        {/* Left side with Logo */}

        <Grid size={{ xs: 12, md: 7, sm: 12 }} className="login__right">
          {/* Right side with Login Form */}

          <div className="login__container login_main">
            <Grid
              size={{ xs: 12, md: 5, sm: 12 }}
              className="login__left"
              sx={{ display: { xs: "block", sm: "block", md: "none" } }}
            >
              <div className="login__left-image">
                <img src={logo} alt="logo" />
              </div>
              <div className="login__left-title">
                <p>Experience Management Portal</p>
              </div>
            </Grid>
            <h1>Log In</h1>
            <form className="login__form" onSubmit={handleLogin}>
              <label>Email</label>
              <TextField
                variant="standard"
                onChange={handleEmailChange}
                error={!!emailError}
                helperText={emailError}
                fullWidth
                className="primary-focused-textfield w-100"
                sx={{ mb: 2, background: "none" }}
              />
              <label>Password</label>
              <TextField
                className="primary-focused-textfield w-100"
                variant="standard"
                type={showPassword ? "text" : "password"}
                onChange={handlePasswordChange}
                error={!!passwordError}
                helperText={passwordError}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        edge="end"
                        className="Icon"
                      >
                        {showPassword ? <EyeIcon /> : <EyehideIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <div className="login__forgot-password">
                <Link
                  to="/forget-password"
                  className="forgot-link"
                  onClick={() => forgotPassword()}
                >
                  Forgot password?
                </Link>
              </div>

              <div className="login__button">
                <Button variant="contained" type="submit" disabled={loading}>
                  {loading ? <span className="loader" /> : "LOG IN"}
                </Button>
              </div>
            </form>
          </div>
          <ToastContainer position="top-right" autoClose={3000} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoginPopup;
